export default {
  name: 'mu-grid-list',
  provide () {
    return {
      getGridListCellHeight: this.getGridListCellHeight,
      getGridListCols: this.getGridListCols,
      getGridListPadding: this.getGridListPadding
    };
  },
  props: {
    cellHeight: {
      type: Number,
      default: 180
    },
    cols: {
      type: Number,
      default: 2
    },
    padding: {
      type: Number,
      default: 4
    }
  },
  methods: {
    getGridListCellHeight () {
      return this.cellHeight;
    },
    getGridListCols () {
      return this.cols;
    },
    getGridListPadding () {
      return this.padding;
    }
  },
  render (h) {
    return h('div', {
      staticClass: 'mu-grid-list',
      style: {
        margin: -this.padding / this.cols + 'px'
      },
      on: this.$listeners
    }, this.$slots.default);
  }
};



// WEBPACK FOOTER //
// ./src/muse-ui/GridList/GridList.js